import { render, staticRenderFns } from "./UnitForm.vue?vue&type=template&id=450db70a&scoped=true&"
import script from "./UnitForm.vue?vue&type=script&lang=js&"
export * from "./UnitForm.vue?vue&type=script&lang=js&"
import style0 from "./UnitForm.vue?vue&type=style&index=0&id=450db70a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450db70a",
  null
  
)

export default component.exports